export default __webpack_public_path__ + "static/media/nomApe.b5299742.png";